import React, { useState, useEffect } from "react";
import api from "../../services/api";
import { useNavigate, useLocation } from "react-router-dom";
import BreadCrumbDiv from "../../components/common/BreadCrumbDiv";
import TextBoxArea from "../../components/common/TextBoxArea";
import CodeSelectBox from "../../components/common/CodeSelectBox";
import SearchInput from "../../components/common/SearchInput";
import SearchButton from "../../components/common/SearchButton";
import ResultWrapUl from "../../components/common/ResultWrapUl";
import FunctionButton from "../../components/common/FunctionButton";
import ButtonWrapDiv from "../../components/common/ButtonWrapDiv";
import { useTranslation } from "react-i18next";

const RegOrganizationPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [region, setRegion] = useState("");
  const [country, setCountry] = useState("");
  const [type, setType] = useState("");
  const [regCode, setRegCode] = useState("");
  const [selectedRegCode, setSelectedRegCode] = useState("");
  const [isRegDisabled, setIsRegDisabled] = useState(true);
  const [isRegListDisabled, setIsRegListDisabled] = useState(true);

  const [sbRegion, setSbRegion] = useState([
    { code: "", codeDesc: `${t("L0049")} *` },
  ]);
  const [sbCountry, setSbCountry] = useState([
    { code: "", codeDesc: `${t("L0050")} *` },
  ]);
  const [sbType, setSbType] = useState([
    { code: "", codeDesc: `${t("L0031")} *` },
  ]);
  const [regList, setRegList] = useState([]);

  useEffect(() => {
    loadRegionData();
    const updateRegionAndCountry = async () => {
      await handleRegionChange({ target: { value: "A1" } });
      setCountry("A10");
      handleCountryChange({ target: { value: "A10" } });
    };

    updateRegionAndCountry();
  }, []);

  useEffect(() => {
    if (type == "" || country == "" || region == "") {
      setIsRegDisabled(true);
      setIsRegListDisabled(true);
    } else {
      setIsRegDisabled(false);
    }
  }, [type, country, region]);

  const loadRegionData = () => {
    api
      .post("/user/code/united", {})
      .then((response) => {
        setSbRegion([
          { code: "", codeDesc: `${t("L0049")} *` },
          ...response.data,
        ]);
      })
      .catch((error) => {
        //TODO
      });
  };

  const handleRegionChange = async (e) => {
    setRegion(e.target.value);

    try {
      const response = await api.post("/user/code/country", {
        sRegion: e.target.value,
      });

      setSbCountry([
        { code: "", codeDesc: `${t("L0050")} *` },
        ...response.data,
      ]);
      setCountry("");
      setSbType([{ code: "", codeDesc: `${t("L0031")} *` }]);
      setType("");
      setSelectedRegCode("");
      setIsRegDisabled(true);
    } catch (error) {}
  };

  const handleCountryChange = (e) => {
    setCountry(e.target.value);

    api
      .post("/user/code/type", {})
      .then((response) => {
        setSbType([
          { code: "", codeDesc: `${t("L0031")} *` },
          ...response.data,
        ]);
        setType("");
        setSelectedRegCode("");
        setIsRegDisabled(true);
      })
      .catch((error) => {
        //TODO
      });
  };

  const handleTypeChange = (e) => {
    setType(e.target.value);
    setSelectedRegCode("");
  };

  const handleRegCodeChange = (e) => {
    setRegCode(e.target.value.trim());
  };

  const handleSelectedRegCodeChange = (e) => {
    setSelectedRegCode(e.target.value.trim());
  };

  const handleSearchClick = () => {
    if (!validate()) {
      return;
    }
    setIsRegListDisabled(false);

    api
      .post("/user/code/registration", {
        sRegion: region,
        sCountry: country,
        sType: type,
        sSearchText: regCode,
      })
      .then((response) => {
        setRegList(response.data);
      })
      .catch((error) => {
        //TODO
      });
  };

  const handleNextClick = () => {
    if (!validate() || !validateJoin()) {
      return;
    }

    if(type === "DEAL") {
      navigate("/join/reg-wacheck", {
        state: {
          united: region,
          country: country,
          location: type,
          loc: selectedRegCode,
        },
      });
    }
    else {
      navigate("/join/reg-agreement", {
        state: {
          united: region,
          country: country,
          location: type,
          loc: selectedRegCode,
        },
      });
    }
  };

  const [joinError, setJoinError] = useState("");

  const validate = () => {
    let isValid = true;

    if (!type) {
      isValid = false;
    }

    if (!country) {
      isValid = false;
    }

    if (!region) {
      isValid = false;
    }
    return isValid;
  };

  const validateJoin = () => {
    let isValid = true;

    if (!selectedRegCode) {
      setJoinError(t("L0343"));
      isValid = false;
    }
    if (isValid) setJoinError("");
    return isValid;
  };

  return (
    <div>
      <BreadCrumbDiv items={[t("L0341"), t("L0342")]}></BreadCrumbDiv>
      <TextBoxArea className={"ptb100"}>
        <h2>{t("L0343")}</h2>

        <CodeSelectBox
          value={region}
          codes={sbRegion}
          onChange={handleRegionChange}
          isCodeVisible={false}
          multiple={false}
        ></CodeSelectBox>

        <CodeSelectBox
          value={country}
          codes={sbCountry}
          onChange={handleCountryChange}
          isCodeVisible={false}
          multiple={false}
        ></CodeSelectBox>

        <CodeSelectBox
          value={type}
          codes={sbType}
          onChange={handleTypeChange}
          isCodeVisible={false}
          multiple={false}
        ></CodeSelectBox>

        <SearchInput
          value={regCode}
          onChange={handleRegCodeChange}
          placeholder={t("L0051")}
          maxLength={20}
          disabled={isRegDisabled}
        ></SearchInput>

        {!isRegDisabled && (
          <SearchButton onClick={handleSearchClick}></SearchButton>
        )}

        {!isRegListDisabled && (
          <ResultWrapUl>
            {regList.length === 0 ? (
              <li>
                {t("L0094")} <br />
                {t("L0095")}
              </li>
            ) : (
              regList.map((reg) => (
                <li key={reg.code}>
                  <input
                    type="radio"
                    id={reg.code}
                    value={reg.code}
                    checked={selectedRegCode == reg.code}
                    onChange={handleSelectedRegCodeChange}
                  />
                  <label htmlFor={reg.code}></label>
                  {reg.codeDesc} ({reg.code})
                </li>
              ))
            )}
          </ResultWrapUl>
        )}
        {joinError && (
          <>
            <br />
            <span style={{ color: "red", fontSize: "15px" }}>{joinError}</span>
          </>
        )}
      </TextBoxArea>

      <ButtonWrapDiv className="btn_bottom">
        <FunctionButton
          className="big"
          value={t("L0355")}
          onClick={handleNextClick}
        ></FunctionButton>
      </ButtonWrapDiv>
    </div>
  );
};

export default RegOrganizationPage;
